import { render, staticRenderFns } from "./IdleWarningDialog.vue?vue&type=template&id=511485a6&scoped=true"
import script from "./IdleWarningDialog.vue?vue&type=script&lang=js"
export * from "./IdleWarningDialog.vue?vue&type=script&lang=js"
import style0 from "./IdleWarningDialog.vue?vue&type=style&index=0&id=511485a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511485a6",
  null
  
)

export default component.exports